import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { HighlightedSearchText } from '../../../HighlightedSearchText'
import Text from '../../../Text'
import { QA_NAME_PDF_VIEWER_SEARCH_RESULT } from '../PdfViewerSearchPanel.constants'

import * as styles from './PdfViewerSearchPanelResult.module.css'

function PdfViewerSearchPanelResult({ isSelected, result, onSelect }) {
  const { t } = useTranslation()

  function handleClick() {
    onSelect(result)
  }

  return (
    <div className={styles.PdfViewerSearchPanelResult}>
      <Text className={styles.pageNumber}>
        {t('PdfViewer.SearchResultPageKey', { number: result.pageNumber })}
      </Text>
      <Text
        Element='button'
        className={classNames(styles.snippet, {
          [styles.selected]: isSelected,
        })}
        qaName={QA_NAME_PDF_VIEWER_SEARCH_RESULT}
        type='button'
        onClick={handleClick}
      >
        <HighlightedSearchText
          className={styles.match}
          query={result.match}
          text={`${result.match}${result.suffix}`}
        />
      </Text>
    </div>
  )
}

export default PdfViewerSearchPanelResult
